import { useCurrency } from '../../hooks/useCurrency';
import type { DentalCurrency } from '../../mocks/dental';

/**
 * Selector de moneda de la página de Odontología.
 *
 * Delega en `useCurrency` para que la moneda elegida sea la misma en todo el
 * sitio (planes generales, dealers y odontología). Los PRECIOS siguen siendo
 * independientes: cada grupo de planes declara sus propios valores fijos.
 */
export function useDentalCurrency(): {
  currency: DentalCurrency;
  setCurrency: (next: DentalCurrency) => void;
} {
  return useCurrency();
}
